export * from './escrow-social.interface';
